import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faDownload,
  faRightFromBracket,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { useInvoiceContext } from "../context";
import { API_BASE_URL } from "../config";
import { STATUS_WAITING, PAY_BOLETO } from "../helpers";

const ModalPayWithBoleto = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isReady, setIsReady] = useState(false);
  const [linkBoleto, setLinkBoleto] = useState("");
  const { invoiceID, invoice, paymentMethod } = useInvoiceContext();

  useEffect(() => {
    const fetchInvoiceBoleto = async () => {
      if (!invoiceID) return;
      if (isReady) return;
      if (paymentMethod !== PAY_BOLETO) return;

      try {
        const response = await fetch(`${API_BASE_URL}/invoice/${invoiceID}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message);
        }

        const data = await response.json();
        console.log(data);

        if (data.invoice.status === STATUS_WAITING) {
          setIsLoading(false);
          setIsReady(true);
          setLinkBoleto(data.invoice.link_provedor);
          if (invoice.invoice.general_info.tipo_pagamento === PAY_BOLETO) {
            window.open(data.invoice.link_provedor, "_blank");
          }
          clearInterval(interval);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    const interval = setInterval(() => {
      if (!invoiceID) return;
      if (isReady) return;
      fetchInvoiceBoleto();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [invoiceID, isReady]);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      centered
    >
      <Modal.Header>
        <FontAwesomeIcon icon={faBarcode} className="me-2 fs-5" />
        <Modal.Title className="w-100">Boleto</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {isLoading && (
          <>
            <h4>Processando...</h4>
            <p className="mb-4">
              Aguarde enquanto estamos gerando o seu boleto...
            </p>
            <div
              className="spinner-border text-success mb-4 fs-5"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </>
        )}
        {isReady && (
          <>
            <h4>Boleto gerado com sucesso!</h4>
            <p className="mb-5">
              <small>Obrigado por utilizar os nossos sistemas.</small>
            </p>
            <p className="mb-5">
              <strong>
                <a href={linkBoleto} target="_blank" rel="noreferrer">
                  <FontAwesomeIcon
                    icon={faDownload}
                    className="me-2"
                    color="#0d6efd"
                  />
                  Clique aqui para baixar o seu boleto
                </a>
              </strong>
            </p>
            <p className="mb-2">
              <text style={{ color: "#d9534f" }}>
                <FontAwesomeIcon
                  icon={faWarning}
                  className="me-2"
                  color="#d9534f"
                />
                <strong style={{ color: "#d9534f" }}>Atenção:</strong> Aguarde ao
                menos 1 hora para o boleto ser registrado no sistema bancário.
              </text>
            </p>
            <Button
              variant="outline-success"
              className="mt-2"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "https://shoficina.com.br";
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ transform: "rotate(180deg)" }}>
                  <FontAwesomeIcon icon={faRightFromBracket} className="ms-2 " />
                </div>
                Voltar para o site
              </div>
            </Button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalPayWithBoleto;
